import type { ComponentCheck } from '../hooks/useTierEvaluation';

/** Tier 0 “how to unlock” shell — placeholder rows until real checks wire through. */
export const TIER_0_UNLOCK_SHELL_CHECKS: ComponentCheck[] = [
  {
    component: 'osVersion',
    label: 'OS',
    currentValue: 'Windows 10',
    score: 0,
    requiredScore: 1,
    passes: false,
  },
  {
    component: 'location',
    label: 'Location',
    currentValue: 'London, England',
    score: 0,
    requiredScore: 1,
    passes: false,
  },
];

export const TIER_0_UNLOCK_INTRO_COPY =
  'Before you can earn rewards, you’ll need to fix a few things on this machine.';
